import React, { useEffect } from 'react';
import { Box, Text, Stack, Flex, Image, Center, Spinner, Icon } from '@chakra-ui/react';
import ReactGA from 'react-ga';
import NumberFormat from 'react-number-format';
import { useHistory } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useUserVestingInfo, getAddrState, useStreamInfo } from '../../api/query';

import { tokenMap } from '../../config/constants';
import Panel from '../../components/panel';
import { toFixed } from '../../utils';
// import {

// } from '../../api/contracts';
// import { useAssetsQuery } from '../../api/query';

const Page = () => {
  const address = getAddrState();
  const {
    isLoading = true,
    data: vestings = [],
    isFetchedAfterMount,
  } = useUserVestingInfo(address);

  useEffect(() => {
    ReactGA.pageview('/vesting');
  }, []);

  const history = useHistory();

  const renderVestingItem = (data: any, idx: number) => {
    // console.log(tokenMap, '===', tokenAddress);
    const { locked, claimable, claimed, streamId, tokenAddress = '' } = data;
    const { token, imgUrl, name } = tokenMap[tokenAddress];

    return (
      <Stack
        h="100px"
        w="100%"
        key={idx}
        borderBottom="1px solid #EEEEEE"
        py={2}
        direction="row"
        cursor="pointer"
        _hover={{ bg: '#fafcfe' }}
        onClick={() => {
          history.push(`/vesting/${streamId}`);
        }}
      >
        <Box w="40%">
          <Flex>
            <Image h="80px" w="80px" src={imgUrl} borderRadius="10px" />
            <Stack ml={4}>
              <Text textStyle="title" minH="35px">
                {`${name} #${streamId}`}
              </Text>

              <Text textStyle="value">
                <Text as="div" textStyle="label" mb={-1} fontSize="12px">
                  Locked ({token})
                </Text>
                <NumberFormat
                  value={toFixed(locked)}
                  displayType={'text'}
                  thousandSeparator={true}
                  renderText={(value) => {
                    const numArr = value.split('.');
                    return (
                      <>
                        {numArr[0]}
                        {numArr[1] && (
                          <Text as="span" fontSize="10px">
                            .{numArr[1]}
                          </Text>
                        )}
                      </>
                    );
                  }}
                />
              </Text>
            </Stack>
          </Flex>
        </Box>
        <Box w="40%">
          <Box h="45px"></Box>
          <Text textStyle="value">
            <Text as="div" textStyle="label" mb={-1} fontSize="12px">
              Claimed ({token})
            </Text>
            <NumberFormat
              value={toFixed(claimed)}
              displayType={'text'}
              thousandSeparator={true}
              renderText={(value) => {
                const numArr = value.split('.');
                return (
                  <>
                    {numArr[0]}
                    {numArr[1] && (
                      <Text as="span" fontSize="12px">
                        .{numArr[1]}
                      </Text>
                    )}
                  </>
                );
              }}
            />
          </Text>
        </Box>
        <Box w="20%" textAlign="right">
          <Box h="45px"></Box>
          <Text textStyle="num">
            <Text as="div" textStyle="label" mb={-1} fontSize="12px">
              Claimable ({token})
            </Text>
            <NumberFormat
              value={toFixed(claimable)}
              displayType={'text'}
              thousandSeparator={true}
              renderText={(value) => {
                const numArr = value.split('.');
                return (
                  <>
                    {numArr[0]}
                    {numArr[1] && (
                      <Text as="span" fontSize="10px">
                        .{numArr[1]}
                      </Text>
                    )}
                  </>
                );
              }}
            />
          </Text>
        </Box>
        <Box w="20px">
          <Box h="60px"></Box>
          <Box>
            <Icon w="24px" h="24px" as={ChevronRightIcon} />
          </Box>
        </Box>
      </Stack>
    );
  };

  return (
    <Panel mt={4}>
      <Text textStyle="title">My investment</Text>
      {isLoading || !address ? (
        <Center h="80vh">
          <Spinner />
        </Center>
      ) : vestings.length ? (
        <Stack mt={4} minH="80vh">
          {vestings.map((d: any, idx: number) => {
            return renderVestingItem(d, idx);
          })}
        </Stack>
      ) : (
        <Center minH="500px" h="80%">
          Empty
        </Center>
      )}
    </Panel>
  );
};

export default Page;
